// extracted by mini-css-extract-plugin
export default {"wrapper":"Forgotten_wrapper_Pf1Xr","logo":"Forgotten_logo_kZMd2"};